import { useCustomerFeedbackModalContext } from "contexts/CustomerFeedbackModalContext";
import React from "react";

import {
  Copyright,
  FooterContainer,
  FooterSubtitle,
  FooterTitle,
  StyledButton,
  StyledFooter,
} from "./style";

const Footer: React.FC = () => {
  const { open: openCustomerFeedbackModal } = useCustomerFeedbackModalContext();
  const currentYear = new Date().getFullYear();
  return (
    <StyledFooter className="py-6" data-test-id="footer">
      <FooterContainer className="container px-6">
        <div>
          <FooterTitle>Support and feedback</FooterTitle>
          <FooterSubtitle>
            Let us know if you encounter any problems using this service or if
            you have feedback to help us improve it.
          </FooterSubtitle>
          <StyledButton
            ariaLabel="Get in touch"
            onClick={openCustomerFeedbackModal}
            buttonText="get in touch"
            className="footer"
          />
        </div>
        <Copyright>&copy; Elexon {currentYear}</Copyright>
      </FooterContainer>
    </StyledFooter>
  );
};

export default Footer;
